import { FeatureFlags } from '@/featureFlags'
import { useFeatureFlag } from '@/hooks/useFeatureFlag'
import { useCourtReporter, useReporter } from '@/providers/UserProvider'
import { AvailabilityOwner } from '@/queries/weeklyAvailability'

export const browserTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

export type AvailabilityOwnerDetails = {
  owner: AvailabilityOwner
  // Used when the week has no timezone yet, which only happens for a court reporter.
  defaultTimezone: string
}

export const useAvailabilityOwner = (): AvailabilityOwnerDetails | null => {
  const reporter = useReporter()
  const courtReporter = useCourtReporter()
  const hasCrAvailability = useFeatureFlag(FeatureFlags.CR_AVAILABILITY)

  if (reporter) {
    return {
      owner: { role: 'reporter', id: reporter.id },
      defaultTimezone: reporter.timezone ?? browserTimezone(),
    }
  }

  if (courtReporter && hasCrAvailability) {
    return {
      owner: { role: 'court_reporter', id: courtReporter.id },
      defaultTimezone: browserTimezone(),
    }
  }

  return null
}
